import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserApi } from '../../shared/services/api/user.api';
import { Beneficjent } from '../../shared/models/beneficjent';
import { APP_PATHS } from '../config/app-paths';
import { ToastSeverity } from '../../shared/enums/toast-severity.enum';
import { MessageService } from 'primeng/api';
import { ApplicationContextService } from '../services/application-context.service';

export const EmailVerifiedGuard: () => Observable<
  Promise<boolean> | boolean
> = (): Observable<Promise<boolean> | boolean> => {
  const userApi = inject(UserApi);
  const router = inject(Router);
  const messageService = inject(MessageService);
  const applicationContextService = inject(ApplicationContextService);
  const beneficjentObservable: Observable<Beneficjent> = userApi.getUser$();

  return beneficjentObservable.pipe(
    map((beneficjent: Beneficjent) => {
      const isEmailVerify = beneficjent.czyZweryfikowanyEmail;
      if (!isEmailVerify) {
        messageService.add({
          severity: ToastSeverity.ERROR,
          summary:
            'Twój adres e-mail wymaga weryfikacji. Dla poprawnego działania w systemie wymagane jest zweryfikowanie adresu e-mail.',
        });
        const url = `${APP_PATHS.userSettings.root}`;
        if (applicationContextService.isOrganizationContext()) {
          applicationContextService.switchToBeneficiary(false);
          return router.navigate([url]);
        } else {
          return router.navigate([url]);
        }
      }
      return true;
    }),
  );
};
